function getAccessToken() {
  const DEV_HOSTNAME = 'peppermayo-dev.myshopify.com';

  const storefrontAccessToken = {
    dev: '6a105536789d7690ca2fd9713c346197',
  };

  switch (Shopify.shop) {
    case DEV_HOSTNAME:
      return storefrontAccessToken.dev;
    default:
      return storefrontAccessToken.dev;
  }
}

function buildImages(images, productID) {
  $(`.card-wrapper[data-card="${productID}"]`)
    .find('.product-temporary')
    .remove();

  let rolloverImg_HTML =
    '<div class="media media--transparent media--hover-effect product-temporary">';
  images.map((image) => {
    const imgUrl = image.node.originalSrc;
    rolloverImg_HTML += `<img src="${imgUrl}" loading="lazy" class="motion-reduce">`;
  });
  rolloverImg_HTML += `</div>`;

  $(`.card-wrapper[data-card="${productID}"]`)
    .find('.card__media')
    .prepend(rolloverImg_HTML);
  $(`.card-wrapper[data-card="${productID}"]`).find('.product-original').hide();
}

function buildQuickAddToCart(variants, id, productID) {
  $(`.variant-selector[data-card="${productID}"]`)
    .find('.product-temporary')
    .remove();

  let form_HTML = `<form id="product-form-${id}" class="product-temporary">`;
  variants.map((variant) => {
    let { id } = variant.node;
    id = id.split('ProductVariant/')[1];
    let { title } = variant.node;
    title = title.split('/')[0];
    const available = variant.node.availableForSale;

    form_HTML += `<button data-variant-id="${id.trim()}"
                            class="${available ? 'available' : 'unavailable'}" 
                            ${available ? '' : 'disabled'}">
                                <span>${title.trim()}</span>
                    </button>`;
  });

  form_HTML += `</form>`;

  $(`.variant-selector[data-card="${productID}"]`).append(form_HTML);
  $(`.variant-selector[data-card="${productID}"]`)
    .find('.product-original')
    .hide();
}

function buildInfo(title, comparePrice, price, currencyCode, productID) {
  $(`.card-wrapper[data-card="${productID}"] .card__information`)
    .find('.product-temporary')
    .remove();
  const titleHTML = `
                <h3 class="card__heading h5 product-temporary">
                    <a
                        href="/products/vans-era-59-frost-gray-chevron"
                        class="full-unstyled-link"
                    >
                        <div class="collection__card-info">
                            <div class="card-info-title">
                                ${title}
                            </div>
                            <span class="title-separator"> | </span>
                            <div class="price ${comparePrice ? 'price--on-sale ' : ''}">
                                <div class="price__container">
                                    <div class="price__regular">
                                        <span class="price-item price-item--regular">
                                            ${currencyCode} $${price}
                                        </span>
                                    </div>
                                    <div class="price__sale">
                                        <span class="visually-hidden visually-hidden--inline">Sale price</span>
                                        <span class="price-item price-item--sale price-item--last">
                                            ${currencyCode}  $${price}
                                        </span>
                                        <span class="visually-hidden visually-hidden--inline">Regular price</span>
                                        <span>
                                            <s class="price-item price-item--regular">NZD $${comparePrice.toFixed(2)}</s>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </h3>
                `;
  $(`.card-wrapper[data-card="${productID}"]`)
    .find('.card__information')
    .prepend(titleHTML);
}

function resetDisplay(productID) {
  $(`.card-wrapper[data-card="${productID}"]`)
    .find('.product-temporary')
    .remove();

  $(`.card-wrapper[data-card="${productID}"]`).find('.product-original').show();
}

function getComparePrice(variants) {
  const comparePrice = variants.map((variant) => variant.node.compareAtPrice);
  const validPrice = comparePrice.filter(
    (price) => price !== null && price !== undefined,
  );
  const min = Math.min(...validPrice);
  return isFinite(min) ? min : 0;
}

function saveData(res) {
  const session_productList = JSON.parse(
    sessionStorage.getItem('product_list'),
  );
  if (session_productList !== null) {
    const index = session_productList.findIndex((prod) => prod.id == res.id);
    if (index === -1) {
      session_productList.push(res);
      sessionStorage.setItem(
        'product_list',
        JSON.stringify(session_productList),
      );
    }
  } else {
    const productList = [];
    productList.push(res);
    sessionStorage.setItem('product_list', JSON.stringify(productList));
  }
  // console.log('productList', JSON.parse(sessionStorage.getItem("product_list")))
}

function changeProductCard(res, productID, event) {
  let { id } = res;
  id = id.split('Product/')[1];
  const images = res.images.edges;
  const variants = res.variants.edges;
  const { title } = res;
  const price = res.priceRange.minVariantPrice.amount;
  const { currencyCode } = res.priceRange.minVariantPrice;
  const comparePrice = getComparePrice(variants);

  saveData(res);
  buildImages(images, productID, event);
  buildQuickAddToCart(variants, id, productID);
  buildInfo(title, comparePrice, price, currencyCode, productID);
}

export default function (event) {
  event.preventDefault();

  $(event.target)
    .parent()
    .siblings('.product-colour-link')
    .removeClass('active');
  $(event.target).parent().addClass('active');

  const productID = $(event.target)
    .closest('.product-colour-swatches')
    .attr('data-card');

  if ($(event.target).parent().hasClass('original')) {
    resetDisplay(productID);
  } else {
    const handle = $(event.target).attr('data-colorhandle');
    const saveProductList = JSON.parse(sessionStorage.getItem('product_list'));
    let isProdSaved = false;

    if (saveProductList != null) {
      const res = saveProductList.filter((product) => product.handle == handle);
      if (res.length) {
        changeProductCard(res[0], productID, event);
        isProdSaved = true;
      }
    }
    if (saveProductList == null || (saveProductList != null && !isProdSaved)) {
      const multipleProductQuery = `{\n        
                    productByHandle(handle: "${handle}") {\n        
                        id\n  
                        title\n 
                        handle\n 
                        tags\n 
                        totalInventory\n
                        priceRange {\n
                            maxVariantPrice {\n
                            amount\n
                            currencyCode\n
                            }\n
                            minVariantPrice {\n
                            currencyCode\n
                            amount\n
                            }\n
                        }\n
                        images(first: 2) {\n 
                            edges {\n 
                                node {\n 
                                    originalSrc\n 
                                }\n 
                            }\n 
                        } \n 
                        variants(first: 30) {\n 
                            edges {\n 
                                node {\n 
                                    id\n 
                                    title\n 
                                    availableForSale\n 
                                    selectedOptions {\n 
                                        name\n 
                                        value\n 
                                    }\n 
                                    compareAtPrice\n 
                                    price\n 
                                }\n 
                            }\n 
                        }\n 
                    }\n
                }`;

      $.ajax({
        url: 'https://'.concat(Shopify.shop, '/api/graphql'),
        method: 'post',
        data: multipleProductQuery,
        headers: {
          'Content-Type': 'application/graphql',
          'X-Shopify-Storefront-Access-Token': getAccessToken(),
        },
        success(data) {
          const res = data.data.productByHandle;
          changeProductCard(res, productID, event);
        },
      });
    }
  }
}
